/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { getRequest, delRequest } from "../../axiosRoutes/index";
import {
  Button,
  Box,
  CircularProgress,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Pagination,
  Snackbar,
  Alert,
  Card,
  CardContent,
  CardActions,
  useMediaQuery,
} from "@mui/material";
import AddInvoice from "./AddInvoice";
import SideNavBar from "../sidebar/SideNav";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { useSnackbar } from "../../axiosRoutes/snackbarConfig";
import { useInView } from 'react-intersection-observer';
import axios from "axios";
import { Preview } from "@mui/icons-material";

const Invoices = () => {
  const { snackbar, showSnackbar, handleSnackbarClose } = useSnackbar();
  const [hover, setHover] = useState(null);
  const isSmallScreen = useMediaQuery("(max-width:900px)");
  const [invoiceStatus, setInvoiceStatus] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [invoiceId, setInvoiceId] = useState(null);
  const [openInvoice, setOpenInvoice] = useState(false);
  const [invoiceData, setInvoiceData] = useState({
    title: "",
    invoiceNumber: "",
    clientName: "",
    projectsList: [],
    currency: "",
    date: "",
    status: "",
  });
  const [loadingMail, setLoadingMail] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [updateId, setUpdateId] = useState(null);
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [isFetchingInvoices, setIsFetchingInvoices] = useState(false)
  const { ref, inView } = useInView({
    threshold: 0,
  });
  const [limit, setLimit] = useState(10)
  const [loadingPreview, setLoadingPreview] = useState(false)

  useEffect(() => {
      if (inView) {
        if(limit < totalPages * 10){
          setLimit(prev=>prev+10)
        }
      }
    }, [inView]);

  const fetchStatus = async () => {
    try {
      const response = await getRequest("filter/invoice");
      const statusArray = Object.keys(response).map((key) => ({
        label: key,
        value: response[key],
      }));
      setInvoiceStatus(statusArray);
    } catch (error) {
      console.error("Error fetching Filter:", error);
    }
  };

  const fetchInvoices = async () => {
    const access = localStorage.getItem("access");
    !isSmallScreen && setLoading(true)
    try {
      setIsFetchingInvoices(true)
      const response = await getRequest("invoice", {
        headers: {
          Authorization: `Bearer ${access}`,
        },
        params: !isSmallScreen ? {page:page} : {limit: limit}
      });
      setIsFetchingInvoices(false)
      setTotalPages(response?.totals?.total_pages)
      const formattedInvoices = response?.data.map((invoice) => {
        if (invoice.date) {
          const date = new Date(invoice.date);
          invoice.date = date.toLocaleDateString("en-GB");
        }
        const statusObj = invoiceStatus.find(
          (status) => status.value === invoice.status
        );
        invoice.status = statusObj ? statusObj.label : invoice.status;
        return invoice;
      });
      setInvoices(formattedInvoices)
    } catch (error) {
      console.error("Error Fetching Invoices:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchStatus();
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (invoiceStatus.length > 0) {
      fetchInvoices();
    }
  }, [invoiceStatus, page, limit]);

  const handleDelete = async () => {
    try {
      const access = localStorage.getItem("access");
      const response = await delRequest(`invoice/${deleteId}`, access);
      fetchInvoices();
      handleClose();
      showSnackbar(response, "success");
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "An error occurred";
      showSnackbar(errorMessage, "error");
    }
  };

  const handleOpen = () => {
    setOpenModal(true);
  };

  const handleClickOpen = (id) => {
    setDeleteId(id);
    setOpen(true);
  };

  const handleMail = async (invoice_id, preview = false) => {
    try {
      if(preview){
        setLoadingPreview(true)
      }
      else{
        setLoadingMail(true)
      }
      const access = localStorage.getItem("access");
      const baseUrl = process.env.REACT_APP_BASE_URL;
      const response = await axios.post(`${baseUrl}invoice/generate/${invoice_id}?preview=${preview}`, {},{
        headers: {Authorization: `Bearer ${access}`},
        ...(preview && { responseType: 'blob' }),
      });
      handleClose();
      !preview && showSnackbar("Mail sent Successfully", "success")
      if(preview){
        const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(pdfBlob);
        window.open(url);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "An error occurred";
      showSnackbar(errorMessage, "error");
    } finally {
      setLoadingPreview(false)
      setTimeout(() => {
        if (preview) {
          setLoadingPreview(false)
        }
        else {
          setLoadingMail(false)
        }
      }, 5000);
    }
  };

  const selectInvoice = (id) => {
    setUpdateId(id);
    handleOpen();
  };

  const handleInvoice = (id) => {
    setOpenInvoice(true);
    setInvoiceId(id);
  };

  useEffect(() => {
    const fetchInvoice = async () => {
      if (invoiceId !== null) {
        const access = localStorage.getItem("access");
        try {
          setLoading(true);
          const res = await getRequest(`invoice/${invoiceId}`, {
            headers: {
              Authorization: `Bearer ${access}`,
            },
          });
          const formatDate = new Date(res.date).toISOString().split("T")[0];
          let returnStatus = () => {
            return invoiceStatus.find(
                        (status) => status.value === res.status
                    )?.label
          }
          setInvoiceData({
            title: res.title,
            invoiceNumber: res.invoiceNumber,
            clientName: res.clientName,
            projectsList: Array.isArray(res.projectsList)
              ? res.projectsList.map((item) => ({
                projectId: item.projectId || "",
                projectName: item.projectName || "",
                hours: item.hours || '',
                amount: item.amount || "",
              }))
              : [],
            currency: res.currency,
            date: formatDate,
            status: returnStatus(),
            work_type: res.work_type,
            taskList: Array.isArray(res.taskList)
              ? res.taskList.map((item) => ({
                id: item.id || "",
                name: item.name || "",
                amount: item.amount || "",
                hours: item.hours || ""
              }))
              : [],
          });
        } catch (error) {
          console.error("Error fetching Invoice:", error);
        } finally {
          setLoading(false);
        }
      } else {
        setInvoiceData({
          title: "",
          invoiceNumber: "",
          clientName: "",
          projectsList: [],
          currency: "",
          date: "",
          status: "",
          work_type: '',
          taskList: []
        });
      }
    };
    fetchInvoice();
  }, [invoiceId]);

  const handleClose = () => {
    setOpenModal(false);
    setOpen(false);
    setOpenInvoice(false)
    fetchInvoices();
    setInvoiceId(null);
    setDeleteId(null);
    setUpdateId(null);
  };

  const headingTableCellStyle = {
    color: "#fff",
    textAlign: "center",
    borderBottom: "2px solid #1F1F1F",
    fontSize: { xs: "0.8rem", sm: "1rem" },
    backgroundColor: '#1F1F1F'
  }
  const dataTableCellStyle = (hover, id) => {
    return {
      color: hover === id ? "#FF5722" : "#fff",
      textAlign: "center",
      borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
      fontSize: { xs: "0.8rem", sm: "1rem" },
      padding: '10px 16px',
      backgroundColor: '#292929'
    };
  };

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        textAlign="center"
      >
        <CircularProgress size={50} sx={{ color: "#FF5722" }} />
        <Typography variant="h6" sx={{ marginTop: "18px", color: "#fff" }}>
          Loading...
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <div className="app-container" style={{ color: "#fff", display: "flex" }}>
        <SideNavBar />
        <div style={{ flex: 1, margin: `${isSmallScreen ? '3.2rem' : '0.5rem'} 0.5rem 0.5rem 0.5rem` }}>
          <Box sx={{ backgroundColor: "#000", marginTop: { xs: 1, md: 0 } }}>
            <Grid
              container
              sx={{
                alignItems: "center",
                justifyContent: "space-between",
                padding: "1rem",
              }}
            >
              <Grid item>
                <h1>Invoices</h1>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  onClick={handleOpen}
                  sx={{
                    backgroundColor: "#fff",
                    color: "black",
                    "&:hover": {
                      backgroundColor: "#e1e1e1",
                    },
                  }}
                >
                  Add Invoice
                </Button>
              </Grid>
            </Grid>
            {invoices.length === 0 ? (
              <Typography variant="h6" sx={{ color: "#fff", textAlign: "center" }}>
                No Data Yet
              </Typography>
            ) : (
              <>
                {!isSmallScreen ? (
                  <TableContainer sx={{ overflowX: "auto", maxWidth: "100vw" }}>
                    <Table
                      style={{
                        borderRadius: "25px",
                        borderCollapse: "separate",
                        overflow: "hidden",
                      }}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell style={headingTableCellStyle}>
                            ID
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Invoice No
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Title
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Client Name
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Project / Task
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Amount
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Date
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Status
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Actions
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {invoices.map((invoice, id) => (
                          <TableRow key={id}
                          style={{
                            cursor: "pointer",
                          }}
                            onMouseEnter={() => setHover(id)}
                            onMouseLeave={() => setHover(null)}
                            onClick={() => handleInvoice(invoice._id)}
                          >
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {(page - 1) * 10 + id + 1}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {invoice.invoiceNumber}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {invoice.title}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {invoice.clientName}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {invoice.work_type === 'project' ? invoice.projectsList.map((project, keys) => (
                                <li key={keys}>{project.projectName}</li>
                              )) : (invoice?.taskList || []).map((task, index) => (
                                <li key={index}>{task.name}</li>
                              ))}
                            </TableCell>
                            <TableCell
                              style={{
                                color: hover === id ? "#FF5722" : "#fff",
                                textAlign: "center",
                                borderBottom:
                                  "1px solid rgba(255, 255, 255, 0.2)",
                                fontSize: { xs: "0.8rem", sm: "1rem" },
                                padding: "10px 16px",
                                backgroundColor: "#292929",
                                minWidth: "100px",
                              }}
                            >
                              {invoice.work_type === 'project' ? invoice.projectsList.map((project, keys) => (
                                <li
                                  key={keys}
                                >{`${project.amount} ${invoice.currency}`}</li>
                              )) : (invoice?.taskList || []).map((task, index)=>(
                                <li key={index}>{task.amount}</li>
                              ))}
                              {}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {invoice.date}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {invoice.status}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              <IconButton
                                sx={{
                                  color: "#fff",
                                  backgroundColor: "#9500ae",
                                  marginRight: "5px",
                                  "&.Mui-disabled": {
                                    backgroundColor: "#e872fdff", 
                                  },
                                  "&:hover": {
                                    backgroundColor: "#9500ae",
                                  }
                                }}
                                aria-label="view"
                                size="small"
                                disabled={(loadingMail && invoiceId === invoice._id)}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setInvoiceId(invoice._id)
                                  handleMail(invoice._id)}}
                              >
                                {(loadingMail && invoiceId === invoice._id) ? (
                                  <CircularProgress size={18} sx={{ color: "#fff" }} />
                                ) : (
                                  <EmailOutlinedIcon fontSize="inherit" />
                                )}
                              </IconButton>
                              <IconButton
                                sx={{
                                  color: "#fff",
                                  backgroundColor: "#1976D2",
                                  marginRight: "5px",
                                  "&.Mui-disabled": {
                                    backgroundColor: "#78b1ebff",
                                  },
                                  "&:hover": {
                                    backgroundColor: "#1976D2",
                                  }
                                }}
                                aria-label="view"
                                size="small"
                                disabled={(loadingPreview && invoiceId === invoice._id)}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setInvoiceId(invoice._id)
                                  handleMail(invoice._id, true)}}
                              >
                                {(loadingPreview && invoiceId === invoice._id) ? (
                                  <CircularProgress size={18} sx={{ color: "#fff" }} />
                                ) : (
                                  <VisibilityIcon fontSize="inherit" />
                                )}
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#4CAF50",
                                  marginRight: "5px",
                                }}
                                aria-label="edit"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  selectInvoice(invoice._id)}}
                              >
                                <EditIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#F44336",
                                  marginRight: "5px",
                                }}
                                aria-label="delete"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleClickOpen(invoice._id)}}
                              >
                                <DeleteIcon fontSize="inherit" />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      <TableFooter style={{ backgroundColor: "#1F1F1F" }}>
                        <TableRow>
                          <TableCell
                            colSpan={100}
                            style={{
                              color: "white",
                              border: "none",
                              textAlign: "center",
                            }}
                          >
                            <Pagination
                              count={totalPages}
                              variant="outlined"
                              color="primary"
                              page={page}
                              onChange={(e, value) => {
                                setPage(value);
                              }}
                              sx={{
                                display: "inline-block",
                                "& .MuiPaginationItem-root": {
                                  color: "#fff",
                                  borderColor: "#fff",
                                  transition: "all 0.3s ease",
                                  "&:hover": {
                                    backgroundColor: "#FF5722",
                                    color: "#fff",
                                    borderColor: "#FF5722",
                                  },
                                  "&.Mui-selected": {
                                    backgroundColor: "#FF5722",
                                    color: "#fff",
                                    borderColor: "#FF5722",
                                  },
                                },
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                ) : (
                  <Grid container spacing={1} justifyContent='center'>
                    {invoices.map((invoice, id) => (
                      <Grid item xs={12} key={id}>
                        <Card ref = {id+1 ===invoices.length ? ref : null}
                          sx={{
                            backgroundColor: "#101010",
                            color: "#fff",
                          }}
                          onMouseEnter={() => setHover(id)}
                          onMouseLeave={() => setHover(null)}
                          onClick={() => handleInvoice(invoice._id)}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <CardContent>
                              <Typography variant="h6">
                                {invoice.title}
                              </Typography>
                              <Typography variant="body2">
                                {invoice.clientName}
                                <br />
                                Status: {invoice.status}
                              </Typography>
                            </CardContent>
                            <CardActions>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#9500ae",
                                  marginRight: "1px",
                                }}
                                aria-label="view"
                                size="medium"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setInvoiceId(invoice._id)
                                  handleMail(invoice._id)
                                }}
                                disabled={loadingMail}
                              >
                                {(loadingMail && invoiceId === invoice._id) ? (
                                  <CircularProgress size={18} sx={{ color: "#fff" }} />
                                ) : (
                                  <EmailOutlinedIcon fontSize="inherit" />
                                )}
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#1976D2",
                                  marginRight: "1px",
                                }}
                                aria-label="view"
                                size="medium"
                                disabled={loadingPreview}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setInvoiceId(invoice._id)
                                  handleMail(invoice._id, true)}}
                              >
                                {(loadingPreview && invoiceId === invoice._id) ? (
                                  <CircularProgress size={18} sx={{ color: "#fff" }} />
                                ) : (
                                  <VisibilityIcon fontSize="inherit" />
                                )}
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#4CAF50",
                                  marginRight: "1px",
                                }}
                                aria-label="edit"
                                size="medium"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  selectInvoice(invoice._id)}}
                              >
                                <EditIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#F44336",
                                  marginRight: "1px",
                                }}
                                aria-label="delete"
                                size="medium"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleClickOpen(invoice._id)}}
                              >
                                <DeleteIcon fontSize="inherit" />
                              </IconButton>
                            </CardActions>
                          </Box>
                        </Card>
                      </Grid>
                    ))}
                    
                  </Grid>
                )}
              </>
            )}
          </Box>
          <Dialog
            open={openInvoice}
            maxWidth
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "#212121",
                opacity: 0.9,
                color: "#fff",
                padding: "5px",
                maxWidth: { xs: "90%", md: "45%" },
                border: "2px solid #D0521B",
              },
            }}
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "22px",
                fontWeight: "bold",
              }}
            >
              {invoiceData.title}
              <IconButton
                onClick={handleClose}
                sx={{
                  color: "#fff",
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Grid container justifyContent="space-between" alignItems="center" sx={{ borderTop: "2px solid #D0521B", paddingTop: "1rem", }}>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Invoice No:</b> {invoiceData.invoiceNumber}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Title:</b> {invoiceData.title}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Client Name:</b> {invoiceData.clientName}
                  </Typography>
                </Grid>
                {invoiceData.work_type === 'project' ? <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Projects Name:</b> {invoiceData.projectsList.map((project) => (
                      `${project.projectName}, `
                    ))}
                  </Typography>
                </Grid> : <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Task:</b> {invoiceData.taskList.map((task) => (
                      `${task.name}, `
                    ))}
                  </Typography>
                </Grid>}
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Date:</b> {invoiceData.date}
                  </Typography>
                </Grid>
                {invoiceData.work_type === 'project' ? <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Amount:</b> {invoiceData.projectsList.map((project, keys) => (
                      `${project.amount} ${invoiceData.currency}, `
                    ))}
                  </Typography>
                </Grid> : <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Amount:</b> {invoiceData.taskList.map((task, keys) => (
                      `${task.amount} ${invoiceData.currency}, `
                    ))}
                  </Typography>
                </Grid>}
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Status:</b> {invoiceData.status}
                  </Typography>
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
          <Dialog
            open={open}
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "#212121",
                color: "#fff",
                padding: "15px",
              },
              "& .MuiDialogTitle-root": {
                padding: "5px",
              },
              "& .MuiDialogContentText-root": {
                color: "#fff",
              },
              "& .MuiDialogContent-root": {
                padding: "5px",
              },
              "& .MuiDialogActions-root": {
                padding: "5px",
              },
            }}
          >
            <DialogTitle>Confirm Deletion</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are You Sure You Want to Delete this Project?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleClose}
                sx={{
                  backgroundColor: "#A6A6A6",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#B8B8B8" },
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleDelete}
                sx={{
                  backgroundColor: "#E5622D",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#D0521B" },
                }}
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
          <AddInvoice
            open={openModal}
            handleClose={handleClose}
            invoiceId={updateId}
          />
        </div>
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {isSmallScreen && <Grid container width='100%' height='10vh' alignItems='center' justifyContent='center' style={{position: 'fixed', bottom: (isFetchingInvoices ? '20px' : '-100px'), transition: 'bottom 0.5s ease'}}>
                    <CircularProgress size="3rem" sx={{color: "#FF5722"}} />
                  </Grid>}
    </>
  );
};

export default Invoices;
